import { useParams } from "react-router-dom";
import { useOrganization } from "../../../../../hooks/query";

export default function useEditOrganization() {
    const { organizationId } = useParams<{ organizationId: string }>();
    const { useUpdate, useDescribe, useUploadLogo } = useOrganization();

    const editOrganizationSvc = useUpdate();
    const uploadLogoSvc = useUploadLogo();
    const { data: organizationData, isLoading, refetch } = useDescribe(organizationId as string);

    const handleEditOrganization = async (data: any) => {
        try {
            const { LogoFile, ...payload } = data;
            let logoUrl = payload.LogoUrl || null;

            if (LogoFile && organizationId) {
                const uploadResult = await uploadLogoSvc.mutateAsync({
                    OrganizationId: organizationId,
                    File: LogoFile,
                });
                logoUrl = uploadResult?.AssetId || logoUrl;
            }

            await editOrganizationSvc.mutateAsync({
                Id: organizationId,
                ...payload,
                LogoUrl: logoUrl || null,
            });
            await refetch();
        } catch (error) {
            console.error("Failed to edit organization", error);
        }
    };

    return {
        editOrganizationSvc: {
            ...editOrganizationSvc,
            isPending: editOrganizationSvc.isPending || uploadLogoSvc.isPending,
            isError: editOrganizationSvc.isError || uploadLogoSvc.isError,
            isSuccess: editOrganizationSvc.isSuccess && !uploadLogoSvc.isError,
        },
        handleEditOrganization,
        organizationData,
        isLoading,
    };
}
